import {useCallback, useMemo} from "react";
import {useSelector} from "../../../__snowpack__/pkg/react-redux.js";
import {useAppDispatch} from "../store.js";
import {selectConfig, selectTheme} from "./white-label.selectors.js";
import {clientInstanceStore} from "./white-label.slice.js";
export function useReduxWhiteLabelTheme() {
  const dispatch = useAppDispatch();
  const state = useSelector(selectTheme);
  return [useMemo(() => state, [state]), useCallback((newState) => dispatch(clientInstanceStore.actions.setTheme(newState)), [dispatch]), useCallback(() => dispatch(clientInstanceStore.actions.resetTheme()), [dispatch])];
}
export function useReduxWhiteLabelConfig() {
  const dispatch = useAppDispatch();
  const state = useSelector(selectConfig);
  return [useMemo(() => state, [state]), useCallback((newState) => dispatch(clientInstanceStore.actions.setConfiguration(newState)), [dispatch]), useCallback(() => dispatch(clientInstanceStore.actions.resetConfiguration()), [dispatch])];
}
